import lodashUniqueId from 'lodash/uniqueId';

/** Generate an array of numbers, counting from zero to the provided number - 1. */

const arrayOfNumbers = length => Array.from({
  length
}).fill(0, 0, length).map((_v, i) => i);
/**
 * Check to see if a thing is a valid number
 * @function
 * @param {any} x
 * @returns {boolean}
 */

const isValidNumber = x => x !== undefined && x !== null && !Number.isNaN(Number.parseFloat(x));
/**
 * Creates upper and lower bounds for a value. Takes the raw value, and an upper (and optionally, also a lower) bound.
 * @function
 * @param {number} value
 * @param {number} max
 * @param {number} [min]
 * @returns {number} The bounded result
 */

const cap = (value, max, min) => {
  if (!isValidNumber(max)) return value;
  if (!isValidNumber(min) && value < 0) return 0; // we know min is a number given the isValidNumber check above, so assert min is a number

  if (value < min) return min;
  if (value > max) return max;
  return value;
};
/**
 * Creates a deterministic, unique string that can be used to identify a component, HTML element,
 * or piece of data. Returns a unique string that appends a page-unique integer to the optional
 * stringBase See https://lodash.com/docs/4.17.15#uniqueId for details.
 *
 * Example Output: uniqueId('foo') => 'foo_1' on first call, 'foo_2' on the second, etc. etc.
 *
 * @param {string} stringBase "base" string to append the unique number part to
 * @returns {string}
 */

const uniqueId = stringBase => lodashUniqueId(`${stringBase !== null && stringBase !== void 0 ? stringBase : 'el'}_`);

export { arrayOfNumbers, cap, isValidNumber, uniqueId };
